import { Avatar, AvatarProps, ICON_PHONE_OUTLINE } from '@doveit/bricks';
import React from 'react';

export type HRRecallAvatarProps = Pick<AvatarProps, 'size' | 'aria-label'>;

export const HRRecallAvatar: React.FC<HRRecallAvatarProps> = (props) => (
  <Avatar
    {...props}
    placeholder={ICON_PHONE_OUTLINE}
  />
);

export default HRRecallAvatar;
